import kirby from '../../api/kirby'

// initial state
const state = {
  site: null
}

// getters
const getters = {}

// actions
const actions = {

  async loadSite ({ commit }) {
    const responses = await Promise.all([
      kirby.getSite(),
      kirby.getPath('/pages/configuration+settings?select=content'),
      fetch('/businesslogic/restaurant/0u636pea.json')
        .then(async (response) => {
          return response.json()
        }),
/*
      fetch('/businesslogic/instagram/recent.json')
        .then(async (response) => {
          return response.json()
        })
*/
    ])

    const site = responses[0].data

    site.settings = responses[1].data.content
    delete site.settings.title // Delete Settings page title
    delete site.settings.logs  // Avoid the site logs to be exposed

    site.restaurant = responses[2]
/*
    site.instagram = {}
    site.instagram.recentPosts = responses[3]
*/
    commit('setSite', site)
  },

  setOpeningStatus ({ commit }, status) {
    commit('setOpeningStatus', status)
  }
}

// mutations
const mutations = {
  setSite (state, site) {
    state.site = site
  },
  setOpeningStatus (state, status) {
    state.site.restaurant.businessHours.states.isOpen = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
